import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                </div>
                <span className="font-heading text-lg font-bold text-foreground-100">
                  蘑菇影视
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                聚集高清、超清、4K、蓝光画质影视资源，免费在线观看，无广告干扰，播放流畅不缓冲。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
                快速导航
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                <Link to="/category/dongzuo" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer">动作片</Link>
                <Link to="/category/dianshiju" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer">电视剧</Link>
                <Link to="/category/dongman" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer">动漫</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
                热门分类
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/kehuan" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer">科幻片</Link>
                <Link to="/category/xiju" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer">喜剧片</Link>
                <Link to="/category/aiqing" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer">爱情片</Link>
                <Link to="/category/kongbu" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer">恐怖片</Link>
                <Link to="/category/jilupian" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap cursor-pointer">纪录片</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
                联系我们
              </h4>
              <div className="flex flex-col gap-3">
                <div className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-mail-line text-sm text-foreground-400"></i>
                  </div>
                  <span className="text-sm text-foreground-400">support@mogutv.com</span>
                </div>
                <div className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-phone-line text-sm text-foreground-400"></i>
                  </div>
                  <span className="text-sm text-foreground-400">400-888-8888</span>
                </div>
                <div className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-map-pin-line text-sm text-foreground-400"></i>
                  </div>
                  <span className="text-sm text-foreground-400">北京市朝阳区影视产业园区</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 蘑菇影视 版权所有 | 京ICP备2024XXXXXXXX号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}